import React, { Component } from 'react';
import { Router, Route, hashHistory, IndexRoute } from 'react-router';
import { Provider } from 'react-redux';
import store from './store/configureStore';
import HomeComponent from './components/HomeComponent';
import MainContainer from './containers/MainContainer';

import CustomersContainer from './containers/CustomersContainer';
import OrdersContainer from './containers/OrdersContainer';
import LabelContainer from './containers/LabelContainer';
import LabelOtherContainer from './containers/LabelOtherContainer';
import ChipUploadContainer from './containers/ChipUploadContainer.jsx';
import FittingContainer from './containers/FittingContainer';
import Fitting1Container from './containers/Fitting1Container';
import PackingContainer from './containers/PackingContainer';
import GearSpecsContainer from './containers/GearSpecsContainer';
import GearModelsContainer from './containers/GearModelsContainer';
import AdvancedSearchContainer from './containers/AdvancedSearchContainer';
import MaintenanceCasesContainer from './containers/MaintenanceCasesContainer';
import AddMaintenanceCaseContainer from './containers/AddMaintenanceCaseContainer';
import MaintenanceOrdersContainer from './containers/MaintenanceOrdersContainer';
import MaintenanceCardsContainer from './containers/MaintenanceCardsContainer';
import CheckCardContainer from './containers/CheckCardContainer';
import ManageCheckItemContainer from './containers/ManageCheckItemContainer';
import MaintenanceRefineContainer from './containers/MaintenanceRefineContainer';
import MaintenanceRefineCardsContainer from './containers/MaintenanceRefineCardsContainer';
import MaintenanceModifyContainer from './containers/MaintenanceModifyContainer';
import MaintenanceFixContainer from './containers/MaintenanceFixContainer';
import MaintenanceFixCardsContainer from './containers/MaintenanceFixCardsContainer';
import MaintenanceFixTargetContainer from './containers/MaintenanceFixTargetContainer';
import MaintenanceAuditContainer from './containers/MaintenanceAuditContainer';
import MaintenanceAuditCardsContainer from './containers/MaintenanceAuditCardsContainer';
import MaintenanceAuditTargetContainer from './containers/MaintenanceAuditTargetContainer';
import PhotographicContainer from './containers/PhotographicContainer';
import PhotoGalleryContainer from './containers/PhotoGalleryContainer';
import PostPhotographicContainer from './containers/PostPhotographicContainer';
import PostPhotoGalleryContainer from './containers/PostPhotoGalleryContainer';
import PhotoListContainer from './containers/PhotoListContainer';
import MaintenanceRfidContainer from './containers/MaintenanceRfidContainer';
import MaintenanceAppendCardsContainer from './containers/MaintenanceAppendCardsContainer';
import MaintenanceAppendModifyContainer from './containers/MaintenanceAppendModifyContainer';
import DownloadMPhotosContainer from './containers/DownloadMPhotosContainer';
import DownloadItemsContainer from './containers/DownloadItemsContainer';
import MaintenanceAuditAppendContainer from './containers/MaintenanceAuditAppendContainer';
import MaintenanceAuditAppendModifyContainer from './containers/MaintenanceAuditAppendModifyContainer';
import MaintenanceSearchContainer from './containers/MaintenanceSearchContainer';

class AppRouter extends Component {
  render() {
    return (
      <div>
        <Provider store={store}>
          <Router history={hashHistory}>
            <Route path="/" component={MainContainer}>
              <IndexRoute component={HomeComponent} />
              {/* 包裝出貨 */}
              <Route path="/customers" component={CustomersContainer} />
              <Route path="/orders" component={OrdersContainer} />
              <Route path="/labels" component={LabelContainer} />
              <Route path="/labelOthers" component={LabelOtherContainer} />
              <Route path="/chipUpload" component={ChipUploadContainer} />
              <Route path="/fitting" component={FittingContainer} />
              <Route path="/fitting1" component={Fitting1Container} />
              <Route path="/advancedSearch" component={AdvancedSearchContainer} />
              <Route path="/packing" component={PackingContainer} />
              <Route path="/gearSpecs" component={GearSpecsContainer} />
              <Route path="/gearModels" component={GearModelsContainer} />
              <Route path="/downloadItems" component={DownloadItemsContainer} />
              {/*清洗維修訂單管理*/}
              <Route path="/maintainOrders" component={MaintenanceOrdersContainer} />
              {/* 清點作業管理 */}
              <Route path="/maintenanceCases" component={MaintenanceCasesContainer} />
              
              {/*清點作業管理 >> 建立標案資訊*/}
              <Route path="/addMaintenanceCase" component={AddMaintenanceCaseContainer} />
              {/*清點作業管理 >> 洗前清點*/}
              <Route path="/maintenanceCards" component={MaintenanceCardsContainer} />
              {/*清點作業管理 >> 洗前清點 >> A001 */}
              <Route path="/maintenanceCard" component={CheckCardContainer} />
              <Route path="/takePhoto" component={PhotographicContainer} />
              <Route path="/readRfid" component={MaintenanceRfidContainer} />
              <Route path="/photoGallery" component={PhotoGalleryContainer} />

              {/* 清點作業確認 */}
              <Route path="/refineCases" component={MaintenanceRefineContainer} />
              {/* 清點作業確認 >> 維修表確認修改 */}
              <Route path="/refineCards" component={MaintenanceRefineCardsContainer} />
              {/* 清點作業確認 >> 維修表確認修改 >> 修改清點細項 */}
              <Route path="/modifyMCard" component={MaintenanceModifyContainer} />

              {/*維修作業*/}
              <Route path="/fixing" component={MaintenanceFixContainer} />
              <Route path="/fixingCards" component={MaintenanceFixCardsContainer} />
              <Route path="/fixingTarget" component={MaintenanceFixTargetContainer} />
              <Route path="/fixingAppend" component={MaintenanceAppendCardsContainer} />
              <Route path="/fixingAppendModify" component={MaintenanceAppendModifyContainer} />
              
              {/*檢點作業*/}
              <Route path="/auditing" component={MaintenanceAuditContainer} />
              <Route path="/auditingCards" component={MaintenanceAuditCardsContainer} />
              <Route path="/auditingTarget" component={MaintenanceAuditTargetContainer} />
              <Route path="/takePostPhoto" component={PostPhotographicContainer} />
              <Route path="/postPhotoGallery" component={PostPhotoGalleryContainer} />
              <Route path="/auditingAppend" component={MaintenanceAuditAppendContainer} />
              <Route path="/auditingAppendModify" component={MaintenanceAuditAppendModifyContainer} />

              {/*照片列表*/}
              <Route path="/photoList" component={PhotoListContainer} />

              {/*下載清洗維修照片/xls檔*/}
              <Route path="/downloadMPhotos" component={DownloadMPhotosContainer} />
              {/*清洗維修記錄查詢*/}
              <Route path="/maintenanceSearch" component={MaintenanceSearchContainer} />

              {/*清洗項目管理*/}
              <Route path="/checkSetting" component={ManageCheckItemContainer} />
            </Route>
          </Router>
        </Provider>
      </div>
    );
  }
}

export default AppRouter;



// WEBPACK FOOTER //
// ./src/AppRouter.js